import EtablissementFnas from '@/generated/controls/etablissement/EtablissementFnas.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: EtablissementFnas
})
